//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import arrayToTree from 'array-to-tree';
import SelectCouponModal from '../../coupons/components/select-coupon-modal';

export default {
    name: 'birthdaySetting',
    components: { SelectCouponModal },
    data() {
        var vm = this;
        return {
            loading: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '规则名称',
                    align: 'center',
                    key: 'name',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.birthdaySettingInfo(row);
                                }
                            }
                        }, row.name));
                        return h('div', actions);
                    }
                },
                {
                    title: '福利类型',
                    align: 'center',
                    key: 'presentTypeStr'
                },
                // {
                //     title: '适用范围',
                //     align: 'center',
                //     render: (h, params) => {
                //         const row = params.row;
                //         for (var i = 0; i < row.cityRanges.length; i++) {
                //
                //         }
                //         return h('div', '');
                //     }
                // },
                {
                    title: '有效期',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        if (row.startDateTimeStr && row.endDateTimeStr) {
                            return h('span', row.startDateTimeStr + '—' + row.endDateTimeStr);
                        } else {
                            return h('span', '');
                        }
                    }
                },
                {
                    title: '状态',
                    align: 'center',
                    key: 'statusStr'
                },
                {
                    title: '创建时间',
                    align: 'center',
                    key: 'creationTimeStr'
                },
                {
                    title: '操作',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        // actions.push(h('Button', {
                        //     props: {
                        //         type: 'primary',
                        //         size: 'small'
                        //     },
                        //     style: {
                        //         marginRight: '5px'
                        //     },
                        //     on: {
                        //         click: () => {
                        //             vm.showNotice(params.row);
                        //         }
                        //     }
                        // }, '通知记录'));

                        // actions.push(h('Button', {
                        //     props: {
                        //         type: 'primary',
                        //         size: 'small'
                        //     },
                        //     style: {
                        //         marginRight: '5px'
                        //     },
                        //     on: {
                        //         click: () => {
                        //             vm.showDetail(params.row);
                        //         }
                        //     }
                        // }, '查看'));

                        var delBtn = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delRule(params.row);
                                }
                            }
                        }, '删除');

                        var editBtn = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.editSetting(params.row);
                                }
                            }
                        }, '编辑');

                        var runBtn = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            loading: {},
                            on: {
                                click: () => {
                                    vm.onNowRun(params.row);
                                }
                            }
                        }, '测试');

                        if (row.status == 0) {
                            // actions.push(editBtn);
                            // actions.push(delBtn);
                        } else {
                            actions.push(runBtn);
                        }


                        return h('div', actions);
                    }
                }
            ],
            list: [],
            totalCount: 0,
            pageSize: 20,
            currentPage: 1,
            showBirthdaySettingEditModal: false,
            showBirthdaySettingModal: false,
            title: '新增规则',
            rules: {
                name: [{ required: true, message: '请输入规则名称', trigger: 'blur' }]
                // couponName: { required: true, message: '请选择优惠券', trigger: 'blur' },
                // presentType: [{ required: true, message: '请输入福利类型', trigger: 'change' }]
            },
            birthdaySetting: {},
            checkAll: false,
            indeterminate: true,
            checkAllGroup: [],
            isEditRange: false,
            showTreeModal: false,
            cityRanges: [],
            projectTree: [],
            saving: false,
            searchInput: {},
            showSelectCouponModel: false
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getPage();
        },
        getPage() {
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            abp.ajax.post('/api/services/app/Birthday/SearchRules', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });

        },
        editSetting(d) {
            // this.birthdaySetting = {
            //     id: 0,
            //     memberLevel: '',
            //     day: 1,
            //     point: 0,
            //     couponId: 0
            // };
            // this.cityRanges = [];
            // this.checkAllGroup = [];
            // this.isEditRange = false;
            // this.$refs.birthdaySettingForm.resetFields();
            // this.birthdaySetting = JSON.parse(JSON.stringify(d));
            // this.cityRanges = this.birthdaySetting.cityRanges;
            // this.pushType = this.birthdaySetting.pushType;
            // if (this.birthdaySetting && this.birthdaySetting.memberLevel.length > 0) {
            //     this.checkAllGroup = this.birthdaySetting.memberLevel.split(',');
            // }
            // if (this.birthdaySetting.id > 0) {
            //     this.title = '编辑规则';
            // } else {
            //     this.title = '新增规则';
            // }
            // this.showBirthdaySettingEditModal = true;

            this.$router.push({
                name: 'birthdayRuleEdit',
                params: {
                    ruleId: d.id
                }
            });
        },
        endDateTimeChange(date) {
            this.birthdaySetting.endDateTime = date;
        },
        startDateTimeChange(date) {
            this.birthdaySetting.startDateTime = date;
        },
        onSave() {
            var vm = this;
            if (!this.birthdaySetting.startDateTime) {
                abp.message.warn('请输入有效开始时间');
                return;
            }
            if (!this.birthdaySetting.endDateTime) {
                abp.message.warn('请输入有效结束时间');
                return;
            }
            if (this.birthdaySetting.presentType == 0 && this.birthdaySetting.point <= 0) {
                abp.message.warn('请输入赠送积分');
                return;
            }
            if (this.birthdaySetting.presentType == 1 && this.birthdaySetting.couponId == 0) {
                abp.message.warn('请选择优惠券');
                return;
            }
            this.birthdaySetting.memberLevel = this.checkAllGroup.toString();

            if (this.isEditRange) {
                this.birthdaySetting.delCityRanges = this.birthdaySetting.cityRanges;
                this.birthdaySetting.cityRanges = vm.cityRanges;
            } else {
                this.birthdaySetting.delCityRanges = [];
            }
            this.birthdaySetting.isEditRange = this.isEditRange;
            this.$refs.birthdaySettingForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Birthday/SaveRule', this.birthdaySetting).then(res => {
                        this.showBirthdaySettingEditModal = false;
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        showDetail(d) {
            this.birthdaySetting = {
                memberLevel: ''
            };
            this.cityRanges = [];
            this.checkAllGroup = [];
            this.isEditRange = false;
            this.birthdaySetting = JSON.parse(JSON.stringify(d));
            this.cityRanges = this.birthdaySetting.cityRanges;
            if (this.birthdaySetting && this.birthdaySetting.memberLevel.length > 0) {
                this.checkAllGroup = this.birthdaySetting.memberLevel.split(',');
            }
            this.showBirthdaySettingModal = true;
        },
        onRelease() {
            this.saving = true;
            abp.ajax.post('/api/services/app/Birthday/ReleaseById?id=' + this.birthdaySetting.id).then(res => {
                this.showBirthdaySettingModal = false;
                this.getPage();
            }).finally(() => {
                this.saving = false;
            });
        },
        showAddACoupon() {
            this.showSelectCouponModel = true;
        },
        addCoupon(data) {
            // console.log(data);
            this.birthdaySetting.couponName = data.name;
            this.birthdaySetting.couponId = data.id;
            this.showSelectCouponModel = false;
        },
        presentTypeChange(val) {
            if (val == 0 || val == '0') {
                this.birthdaySetting.couponName = '';
                this.birthdaySetting.couponId = 0;
            } else {
                this.birthdaySetting.point = 0;
            }
        },
        getProjectStagesTree() {
            abp.ajax.get('/api/services/app/Project/GetProjectStagesTree').then(res => {
                this.projectTree = [];
                this.projectTree = res.data.result.items;
                this.projectTree.forEach((item, index) => {
                    item.title = item.name;
                    item.children = item.projects;
                    item.type = 'city';
                    item.children.forEach(item => {
                        item.children = item.stages;
                        item.parentId = item.cityId;
                        item.type = 'project';
                        item.children.forEach(i => {
                            i.parentId = i.projectId;
                            i.type = 'fenqi';
                        });
                    });
                });

                this.projectTree = arrayToTree(this.projectTree, {
                    parentProperty: 'parentId',
                    customID: 'id'
                });
            }).finally(() => {
                // this.saving = false;
            });
        },
        onSelectTree() {
            var list = this.$refs.treeRef.getCheckedAndIndeterminateNodes();
            this.cityRanges = [];
            var select = list.filter(x => x.type === 'city');
            select.forEach(city => {
                this.cityRanges.push({
                    id: 0,
                    businessId: 0,
                    cityId: city.id,
                    businessType: 'Questionnaire',
                    cityName: city.title,
                    isAllCity: city.checked
                });
            });
            for (var i = 0; i < this.cityRanges.length; i++) {
                this.cityRanges[i].projectRanges = [];
                var s1 = list.filter(x => x.cityId === this.cityRanges[i].cityId);
                var sss = [];
                s1.forEach(project => {
                    sss.push({
                        id: 0,
                        cityRangeId: 0,
                        projectId: project.id,
                        projectName: project.title,
                        cityId: project.cityId,
                        isAllProject: project.checked
                        // projectId: item.projectId
                    });
                });

                this.cityRanges[i].projectRanges = sss;

                for (var j = 0; j < this.cityRanges[i].projectRanges.length; j++) {
                    this.cityRanges[i].projectRanges[j].stagesRanges = [];
                    var s2 = list.filter(x => x.projectId === this.cityRanges[i].projectRanges[j].projectId);

                    var ssss = [];
                    s2.forEach(s => {
                        ssss.push({
                            id: 0,
                            projectRangeId: 0,
                            name: s.title,
                            projectId: s.projectId
                        });
                    });
                    this.cityRanges[i].projectRanges[j].stagesRanges = ssss;
                }

            }
            this.showTreeModal = false;
            this.isEditRange = true;
        },
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                // this.checkAllGroup = ['1', '2', '3', '4'];
                this.checkAllGroup = ['1', '2', '3', '4'];
            } else {
                this.checkAllGroup = [];
            }
        },
        checkAllGroupChange(data) {
            if (data.length === 4) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        showNotice(row) {
            this.$router.push({
                name: 'birthdayWishes',
                params: {
                    ruleId: row.id
                }
            });
        },
        onNowRun(row) {
            if (row.status == 0) {
                abp.message.error('规则未生效');
                return;
            }
            if (row.id == 0) {
                return;
            }
            this.saving = true;
            abp.ajax.post('/api/services/app/Birthday/SaveNoticeTask?ruleId=' + row.id).then(res => {

            }).finally(() => {
                this.saving = false;
            });
        },
        delRule(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    abp.ajax.delete('/api/services/app/Birthday/DeleteRule?id=' + row.id).then(res => {
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        birthdaySettingInfo(row) {
            this.$router.push({
                name: 'birthdaySettingInfo',
                params: {
                    ruleId: row.id
                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
        this.getProjectStagesTree();
    }
};
